import { useEffect } from 'react';

import useRootNodeRef from './useRootNodeRef';

interface IUseViewScrollDetector {
  setIsViewTop: (value: boolean) => void;
}

export const useViewScrollDetector = ({ setIsViewTop }: IUseViewScrollDetector) => {
  const { ref } = useRootNodeRef();

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        setIsViewTop(ref.current.getBoundingClientRect().top >= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return { ref };
};
